import React, { useState, useEffect, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import {
  getTodaysData,
  validateAadhar,
  //eslint-disable-next-line
  validateBankAccount,
  validateContactNumber,
  validateEmail,
  validateName,
  validatePAN,
  validateRequired,
  validPostalCode,
} from "../../../../common/Validations";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import Layout from "../../../../Layout/Layout";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import CustomerConstants from "../../../../common/CustomerConstants";
import toast from "react-hot-toast";
import {
  vendorCategoryData,
  dropdownOption,
  failureModalData,
  doctorManagerDropDownOption,
  employeeGender,
  ID_PROOF_OPTIONS,
  NURSE_CATEGORY_OPTIONS,
  NURSE_SPECIALIZATION_OPTIONS,
} from "./UserRegistrationConstant";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_BANK_ACC: "validate bank account number",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  MOBILE_NUMBER: "Please enter a valid mobile number",
};

const UserRegistrationDetailsMR = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Master");
  localStorage.setItem("submenu", "Hospital-Patient");

  const appConfig = useSelector((state) => state?.app?.appConfig);
  let userData = useSelector((state) => state?.user?.data);
  // let supplierID = useSelector((state) => state?.supplier?.supplierID);
  let userInfo = useSelector((state) => state?.user?.data);
  let supplierID = useSelector((state) => state?.customer?.mrUserList?.userId); // User Details from Store

  // eslint-disable-next-line
  const SalesOfficerData = [
    { id: 1, code: "M000", name: "Medirent" },
    { id: 2, code: "ST10", name: "Ganesh" },
    { id: 3, code: "MJ25", name: "Manoj" },
  ];

  // ============================================================================
  // STATE DECLARATIONS
  // ============================================================================

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);

  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);

  const [patientDocuments, setPatientDocuments] = useState({
    aadharCardAttachment: "",
    aadharCardFileName: "",
    panCardAttachment: "",
    panCardFileName: "",
    weight: "",
    age: "",
    patientChallanges: "",
    caregiverName: "",
    emailId: "",
    caregiverRelation: "",
    idProof: "",
    idProofNumber: "",
  });

  const [edit, setEdit] = useState(true);
  const [disabled, setDisabled] = useState(true);

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([]);
  const [getdocumentType, setdocumentType] = useState([]);
  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [validation, setValidation] = useState({});

  const [getBankDetails, setBankDetails] = useState([]);
  const [getBankDetailsData, setBankDetailsData] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // eslint-disable-next-line
  const [getCustomerTypeCode, setCustomerTypeCode] = useState();

  const [getVendorCategory, setVendorCategory] = useState([]);
  const [selectedVendorCategory, setSelectedVendorCategory] = useState(null);

  const [originalFormData, setOriginalFormData] = useState(null);
  const [originalVendorCategory, setOriginalVendorCategory] = useState(null);
  const [originalSelectedVendorCategory, setOriginalSelectedVendorCategory] =
    useState(null);
  const [originalContactPerson, setOriginalContactPerson] = useState([]);
  const [originalDocuments, setOriginalDocuments] = useState([]);
  const [originalBankDetails, setOriginalBankDetails] = useState([]);
  const [originalDoctorsList, setOriginalDoctorsList] = useState([]);

  const [getDoctorsList, setDoctorsList] = useState([]);

  const [getSalesOfficerList, setSalesOfficerList] = useState([]);

  const [serviceProviderList, setServiceProviderList] = useState([]);

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    employeeName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",
    companyCode: "",
    version: "v0",
    status: "Registered",
    category: "VENDOR",
    joiningDate: getTodaysData(),
    email: "",
    mobileNr: "",
    plantAddress: appConfig?.customerPlantAddress || "",

    // V11 Doctor fields
    doctorTitle: "",
    // doctorEmpName: "",
    doctorSpecialityCode: "",
    doctorSpecialityName: "",
    doctorType: "",
    employeeGender: "",
    doctorClass: "",
    doctorRentPercentage: "",
    doctorDiscountPercentage: "",
    doctorHospitalName: "",
    doctorHospitalAddress: "",
    doctorHospitalCity: "",
    doctorHospitalState: "",
    doctorHospitalCountry: "",
    doctorHospitalPincode: "",
    doctorManagerName: "",
    doctorManagerNameCode: "",
    doctorGNT: "",

    // --- (V13) ---
    serviceProviderName: "",
    serviceProviderCode: "",
    nurseCategory: "",
    nurseCategoryCode: "",
    nurseSpecialization: "",
    nurseSpecializationCode: "",
    nurseExperience: "",
    nurseRegNo: "",
    nurseLanguages: "",

    // --- (V14) ---
    servicePersonExpertise: "",
    servicePersonExperience: "",
    servicePersonGender: "",
  });

  const doctorInitialData = {
    id: Date.now(),
    doctorName: "",
    doctorTitle: "",
    doctorSpecialityCode: "",
    doctorSpecialityName: "",
    doctorType: "",
    doctorGender: "",
    doctorClass: "",
    doctorRentPercentage: "",
    doctorDiscountPercentage: "",
  };

  const bankInfoInitialData = {
    id: Date.now().toString(),
    bankAccountNumber: "",
    bankIFSC: "",
    bankBranchName: "",
    bankCountryDescription: "",
    bankAddress: "",
    AccountHolderName: "",
    preferredCurrency: "INR",
    swiftIfscCode: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
  };

  // ============================================================================
  // UTILITY FUNCTIONS
  // ============================================================================

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    if (dateString.includes("-")) {
      const parts = dateString.split("-");
      if (parts[0].length === 2 && parts[2].length === 4) {
        const [day, month, year] = parts;
        return `${year}-${month}-${day}`;
      }
    }
    return dateString;
  };

  const toggleCardVisibility = () => setCardVisible(!isCardVisible);
  const toggleCardVisibility2 = () => setCardVisible2(!isCardVisible2);
  const toggleCardVisibility3 = () => setCardVisible3(!isCardVisible3);
  const toggleCardVisibility8 = () => setCardVisible8(!isCardVisible8);
  const toggleCardVisibility10 = () => setCardVisible10(!isCardVisible10);

  // ============================================================================
  // LOAD DATA FROM BACKEND - FIXED
  // ============================================================================

  const loadFirstLevelData = useCallback(async () => {
    if (supplierID || userInfo?.userId) {
      let obj = { userId: supplierID || userInfo?.userId };

      const toastId = toast.loading("Loading...", { position: "top-right" });

      try {
        const item = await ItemService.getUserDetail(obj);

        if (item?.status === 200) {
          const backendData = item?.data;
          //  Extract doctor details from doctorsDetails array for V11
          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory.length > 0
          ) {
            const vendorCode = backendData.vendorCategory[0].vendorCategoryCode;

            // If V11 (Doctor), extract doctor info from doctorsDetails[0]
            if (
              (vendorCode === "V11" || vendorCode === "V12") &&
              backendData.doctorsDetails &&
              backendData.doctorsDetails.length > 0
            ) {
              const doctorInfo = backendData.doctorsDetails[0];

              // Merge doctor info into formInputs
              backendData.doctorTitle = doctorInfo.doctorTitle || "";
              // backendData.doctorEmpName = doctorInfo.doctorEmpName || "";
              backendData.doctorSpecialityCode =
                doctorInfo.doctorSpecialityCode || "";
              backendData.doctorSpecialityName =
                doctorInfo.doctorSpecialityName || "";
              backendData.doctorType = doctorInfo.doctorType || "";
              backendData.employeeGender = doctorInfo.doctorGender || "";
              backendData.doctorClass = doctorInfo.doctorClass || "";
              backendData.doctorRentPercentage =
                doctorInfo.doctorRentPercentage || "";
              backendData.doctorDiscountPercentage =
                doctorInfo.doctorDiscountPercentage || "";
              backendData.doctorHospitalName =
                doctorInfo.doctorHospitalName || "";
              backendData.doctorHospitalAddress =
                doctorInfo.doctorHospitalAddress || "";
              backendData.doctorHospitalCity =
                doctorInfo.doctorHospitalCity || "";
              backendData.doctorHospitalState =
                doctorInfo.doctorHospitalState || "";
              backendData.doctorHospitalCountry =
                doctorInfo.doctorHospitalCountry || "";
              backendData.doctorHospitalPincode =
                doctorInfo.doctorHospitalPincode || "";
              backendData.doctorManagerName =
                doctorInfo.doctorManagerName || "";
              backendData.doctorManagerCode =
                doctorInfo.doctorManagerCode || "";
              backendData.doctorGNT = doctorInfo.doctorGNT || "";
            }
          }

          setFormInputs(backendData);

          setPatientDocuments({
            aadharCardAttachment: backendData.aadharCardAttachment || "",
            aadharCardFileName: backendData.aadharCardFileName || "",

            panCardAttachment: backendData.panCardAttachment || "",
            panCardFileName: backendData.panCardFileName || "",
          });

          setcustomerContactPerson(
            (backendData?.contactDetails || []).map((item, idx) => ({
              ...item,
              id: item._id || item.id || `contact-${idx}`,
            })),
          );

          setDocumentTypeData(
            (backendData?.certifications || []).map((item, idx) => ({
              ...item,
              id: item._id || item.id || `doc-${idx}`,
            })),
          );

          setBankDetails(
            (backendData?.bandkDetails || backendData?.bankDetails || []).map(
              (item, idx) => ({
                ...item,
                id: item._id || item.id || `bank-${idx}`,
              }),
            ),
          );

          //  For V04 (Hospital), set doctors list
          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory[0]?.vendorCategoryCode === "V04"
          ) {
            setDoctorsList(
              (backendData?.doctorsDetails || []).map((item, idx) => ({
                ...item,
                id: item._id || item.id || `doctor-${idx}`,
              })),
            );
          } else {
            setDoctorsList([]); // Clear for non-hospital categories
          }

          // console.log("Above matchedCategory");

          // Transform vendorCategory from backend
          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory.length > 0
          ) {
            const backendCategory = backendData.vendorCategory[0];
            const matchedCategory = vendorCategoryData.find(
              (cat) => cat.code === backendCategory.vendorCategoryCode,
            );

            if (matchedCategory) {
              setSelectedVendorCategory({
                id: matchedCategory.id,
                code: matchedCategory.code,
                name: matchedCategory.name,
                description: matchedCategory.description,
              });

              setVendorCategory([
                {
                  vendorCategoryCode: backendCategory.vendorCategoryCode,
                  vendorCategoryDesc:
                    backendCategory.vendorCategoryDesc ||
                    backendCategory.vendorCategoryDescription,
                  vendorCategoryName:
                    backendCategory.vendorCategoryName ||
                    backendCategory.vandorCategory,
                },
              ]);
            }
          }

          // Store originals
          setOriginalFormData(JSON.parse(JSON.stringify(backendData)));

          setOriginalVendorCategory(
            backendData?.vendorCategory ? [...backendData.vendorCategory] : [],
          );

          setOriginalContactPerson(
            backendData?.contactDetails ? [...backendData.contactDetails] : [],
          );

          setOriginalDocuments(
            backendData?.certifications ? [...backendData.certifications] : [],
          );

          setOriginalBankDetails(
            backendData?.bandkDetails || backendData?.bankDetails
              ? [...(backendData.bandkDetails || backendData.bankDetails)]
              : [],
          );

          // Store original doctors list (for V04)
          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory[0]?.vendorCategoryCode === "V04"
          ) {
            setOriginalDoctorsList(
              backendData?.doctorsDetails
                ? [...backendData.doctorsDetails]
                : [],
            );
          } else {
            setOriginalDoctorsList([]);
          }

          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory.length > 0
          ) {
            const backendCategory = backendData.vendorCategory[0];
            const matchedCategory = vendorCategoryData.find(
              (cat) => cat.code === backendCategory.vendorCategoryCode,
            );
            if (matchedCategory) {
              setOriginalSelectedVendorCategory({
                id: matchedCategory.id,
                code: matchedCategory.code,
                name: matchedCategory.name,
                description: matchedCategory.description,
              });
            }
          }
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }

        toast.dismiss(toastId);
      } catch (error) {
        console.error("Error loading data:", error);
        toast.error("Failed to load data", { position: "top-right" });
        toast.dismiss(toastId);
      }
    } else {
      navigate(CustomerConstants.SUPPILER_LIST_MR);
    }
  }, [supplierID, userInfo?.userId, navigate]);

  useEffect(() => {
    loadFirstLevelData();
  }, [loadFirstLevelData]);

  // ============================================================================
  // MASTER DATA LOADING
  // ============================================================================

  const getBankMasterData = useCallback(async () => {
    try {
      const item = await ItemService.getBankMasterData();
      if (item?.status === 200) setBankDetailsData(item.data);
    } catch (error) {
      console.error("Error loading bank data:", error);
    }
  }, []);

  // Add this function
  const fetchServiceProviderList = useCallback(async () => {
    try {
      const payload = {
        queryName: "getSupplierList",
        module: "",
        page: 1,
        per_page: 1000,
        timeZone: "Asia/Calcutta",
        rowFilter: {
          $and: [{ "vendorCategory.vendorCategoryCode": "V06" }],
        },
      };
      const response = await ItemService.generateQuery(payload);
      if (response?.status === 200 && Array.isArray(response.data)) {
        const formattedList = response.data.map((provider) => ({
          id: provider.userId || provider._id,
          name: provider.organisationName || provider.employeeName,
          code: provider.userId,
        }));
        setServiceProviderList(formattedList);
      }
    } catch (err) {
      console.error(err);
    }
  }, []); // no external dependencies

  const fetchSalesOfficerList = useCallback(async () => {
    try {
      const response = await ItemService.generateQuery({
        queryName: "Get_SalesOfficerNames",
        page: 1,
        per_page: 9999,
        timeZone: "Asia/Calcutta",
      });
      if (response?.status === 200 && Array.isArray(response.data)) {
        const formattedList = response.data.map((officer) => ({
          id: officer.salesOfficerCode,
          name: officer.salesOfficerName,
          code: officer.salesOfficerCode,
          description: officer.desc,
        }));
        setSalesOfficerList(formattedList);
      } else {
        setSalesOfficerList([]);
      }
    } catch (error) {
      console.error("Error fetching sales officers:", error);
      toast.error("Failed to load Sales Officer list");
      setSalesOfficerList([]);
    }
  }, []); // no external dependencies

  const getMasterData = useCallback(async () => {
    try {
      const [titleRes, docTypeRes, jobTitleRes, countryRes, companyRes] =
        await Promise.all([
          ItemService.getMasterDataSelf({ codeType: "title" }),
          ItemService.getMasterDataSelf({ codeType: "documentType" }),
          ItemService.getMasterDataSelf({ codeType: "jobtitle" }),
          ItemService.getMasterDataSelf({ codeType: "country" }),
          ItemService.generateCustomerQuery({
            queryName: "Get_CompanyMaster_List",
            page: 1,
            per_page: 9999,
            searchTerm: "",
            timeZone: "Asia/Calcutta",
          }),
        ]);

      if (titleRes?.status === 200) setTitle(titleRes.data);
      if (docTypeRes?.status === 200) setdocumentType(docTypeRes.data);
      if (jobTitleRes?.status === 200) setcontactPosition(jobTitleRes.data);
      if (countryRes?.status === 200) setCountry(countryRes.data);
      if (companyRes?.status === 200) setCompanyCode(companyRes.data);

      //  Sales officer API call
      await fetchSalesOfficerList();
    } catch (error) {
      console.error("Error loading master data:", error);
    }

    //eslint-disable-next-line
  }, []); // no external dependencies

  const getStateData = async (code) => {
    const item = await ItemService.getMasterDataSelf({
      codeType: "region",
      code: code,
    });
    if (item?.status === 200) setState(item.data);
  };

  // Trigger fetch when editing a V13 user or V14
  useEffect(() => {
    if (
      !edit &&
      (selectedVendorCategory?.code === "V13" ||
        selectedVendorCategory?.code === "V14")
    ) {
      fetchServiceProviderList();
    }
  }, [edit, selectedVendorCategory, fetchServiceProviderList]);

  useEffect(() => {
    getMasterData();
    getBankMasterData();
  }, [getMasterData, getBankMasterData]);

  // ============================================================================
  // DROPDOWN HANDLERS
  // ============================================================================

  useEffect(() => {
    if (!getDropdownData) return;

    if (getDropdownData?.codeType === "country") {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData.textField]: getDropdownData.name,
        [getDropdownData.textCode]: getDropdownData.code,
        [getDropdownData.textDesc]: getDropdownData.description,
      }));
      getStateData(getDropdownData.code);
    } else if (getDropdownData?.textField === "state") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "vendorCategory") {
      setSelectedVendorCategory({
        id: getDropdownData.id,
        code: getDropdownData.code,
        name: getDropdownData.name,
        description: getDropdownData.description,
      });

      setVendorCategory([
        {
          vendorCategoryCode: getDropdownData.code,
          vendorCategoryDesc: getDropdownData.description,
          vendorCategoryName: getDropdownData.name,
        },
      ]);

      setValidation((prev) => ({ ...prev, vendorCategory: "" }));
    } else if (getDropdownData?.textField === "companyCode") {
      setFormInputs((prev) => ({
        ...prev,
        companyCode: getDropdownData.companyCode,
        companyCodeCode: getDropdownData.companyCodeCode,
        companyCodeDesc: getDropdownData.companyCodeDesc,
      }));
    } else if (getDropdownData?.textField === "employeeGender") {
      setFormInputs((prev) => ({
        ...prev,
        employeeGender: getDropdownData.name,
        employeeGenderCode: getDropdownData.code,
      }));
    } else if (getDropdownData?.textField === "doctorManagerName") {
      setFormInputs((prev) => ({
        ...prev,
        doctorManagerName: getDropdownData.name,
        doctorManagerNameCode: getDropdownData.code,
      }));
    } else if (getDropdownData?.textField === "doctorGNT") {
      setFormInputs((prev) => ({
        ...prev,
        doctorGNT: getDropdownData.name,
        doctorGNTCode: getDropdownData.code,
      }));
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData.index
            ? {
                ...doc,
                contactPosition: getDropdownData.name,
                contactPositionCode: getDropdownData.code,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData.index
            ? {
                ...doc,
                contactTitle: getDropdownData.name,
                contactTitleCode: getDropdownData.code,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData.index
            ? {
                ...doc,
                documentType: getDropdownData.name,
                documentTypeCode: getDropdownData.code,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.textField === "doctorGender") {
      setDoctorsList((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData.index
            ? { ...doc, doctorGender: getDropdownData.name }
            : doc,
        ),
      );
    } else if (getDropdownData?.textField === "swiftIfscCode") {
      setBankDetails((prev) =>
        prev.map((bank) =>
          bank.id === getDropdownData.index
            ? {
                ...bank,
                swiftIfscCode: getDropdownData.name,
                swiftIfscCodeCode: getDropdownData.code,
              }
            : bank,
        ),
      );
    } else if (getDropdownData?.textField === "salesOfficerName") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "idProof") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "nurseCategory") {
      setFormInputs((prev) => ({
        ...prev,
        nurseCategory: getDropdownData?.name,
        nurseCategoryCode: getDropdownData?.code,
      }));
    } else if (getDropdownData?.textField === "nurseSpecialization") {
      setFormInputs((prev) => ({
        ...prev,
        nurseSpecialization: getDropdownData?.name,
        nurseSpecializationCode: getDropdownData?.code,
      }));
    } else if (getDropdownData?.textField === "serviceProviderName") {
      setFormInputs((prev) => ({
        ...prev,
        serviceProviderName: getDropdownData?.name,
        serviceProviderCode: getDropdownData?.code,
      }));
    } else if (getDropdownData?.textField === "patientGender") {
      setFormInputs((prev) => ({
        ...prev,
        patientGender: getDropdownData?.name,
        patientGenderCode: getDropdownData?.code,
      }));
    }

    setValidation((prev) => ({ ...prev, [getDropdownData?.textField]: "" }));
  }, [getDropdownData]);

  // ============================================================================
  // INPUT HANDLERS
  // ============================================================================

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => ({ ...prev, [name]: value }));

    const errors = {};

    if (name === "employeeName") {
      if (!validateName(value)) {
        errors.employeeName = message.VALID_CUSTOMER_NAME;
      }
    }

    if (name === "cityPostalCode") {
      if (!validPostalCode(value)) {
        errors.cityPostalCode = message.VALID_POSTAL_CODE;
      }
    }

    if (name === "email") {
      if (!validateEmail(value)) {
        errors.email = message.VALID_MAIL_ID;
      }
    }

    if (name === "mobileNr") {
      if (!validateContactNumber(value)) {
        errors.mobileNr = message.MOBILE_NUMBER;
      }
    }

    //-- EmailId of caregiver  validation
    if (name === "emailId") {
      if (!validateEmail(value)) {
        errors.email = message.VALID_MAIL_ID;
      } else {
        errors.email = "";
      }
    }

    setValidation((prev) => ({ ...prev, [name]: errors[name] || "" }));
  };

  // ============================================================================
  // EDIT/CANCEL/UPDATE
  // ============================================================================

  const handleEdit = () => {
    setEdit(false);
    setDisabled(false);
  };

  const handleCancel = () => {
    setEdit(true);
    setDisabled(true);

    if (originalFormData)
      setFormInputs(JSON.parse(JSON.stringify(originalFormData)));
    if (originalVendorCategory) setVendorCategory([...originalVendorCategory]);
    if (originalSelectedVendorCategory)
      setSelectedVendorCategory({ ...originalSelectedVendorCategory });
    if (originalContactPerson)
      setcustomerContactPerson([...originalContactPerson]);
    if (originalDocuments) setDocumentTypeData([...originalDocuments]);
    if (originalBankDetails) setBankDetails([...originalBankDetails]);
    if (originalDoctorsList) setDoctorsList([...originalDoctorsList]);

    setValidation({});
  };

  //  BUILD PAYLOAD FOR UPDATE
  const buildPayload = () => {
    // STEP 1: Start with full formInputs spread (preserves ALL backend fields)
    const payload = {
      ...formInputs,

      // Override specific computed fields
      firstName: formInputs.employeeName,
      organisationName: formInputs.employeeName,
      vendorCategory: getVendorCategory,
      customerTypeCode: getCustomerTypeCode || "S01",
      disableWorkFlow: true,

      // STEP 2: Use direct references (not .map) to preserve all fields
      contactDetails: getcustomerContactPerson,
      certifications: getDocumentTypeData,
      bandkDetails: getBankDetails,

      // --- V13 Specifics ---
      serviceProviderName: formInputs.serviceProviderName,
      serviceProviderCode: formInputs.serviceProviderCode,
      nurseRegNo: formInputs.nurseRegNo,
      nurseExperience: formInputs.nurseExperience,
      nurseCategory: formInputs.nurseCategory,
      nurseCategoryCode: formInputs.nurseCategoryCode,
      nurseSpecialization: formInputs.nurseSpecialization,
      nurseSpecializationCode: formInputs.nurseSpecializationCode,
      nurseLanguages: formInputs.nurseLanguages,
    };

    // STEP 3: Conditional logic per category
    if (selectedVendorCategory?.code === "V11") {
      payload.hospitalName = formInputs.doctorHospitalName;
      payload.doctorsDetails = [
        {
          doctorName: formInputs.employeeName,
          doctorTitle: formInputs.doctorTitle,
          // doctorEmpName: formInputs.doctorEmpName,
          doctorSpecialityCode: formInputs.doctorSpecialityCode,
          doctorSpecialityName: formInputs.doctorSpecialityName,
          doctorType: formInputs.doctorType,
          doctorGender: formInputs.employeeGender,
          doctorClass: formInputs.doctorClass,
          doctorRentPercentage: formInputs.doctorRentPercentage,
          doctorDiscountPercentage: formInputs.doctorDiscountPercentage,
          doctorHospitalName: formInputs.doctorHospitalName,
          doctorHospitalAddress: formInputs.doctorHospitalAddress,
          doctorHospitalCity: formInputs.doctorHospitalCity,
          doctorHospitalState: formInputs.doctorHospitalState,
          doctorHospitalCountry: formInputs.doctorHospitalCountry,
          doctorHospitalPincode: formInputs.doctorHospitalPincode,
          doctorManagerName: formInputs.doctorManagerName,
          doctorGNT: formInputs.doctorGNT,
          doctorManagerCode: formInputs.doctorManagerNameCode,
        },
      ];
    } else if (selectedVendorCategory?.code === "V04") {
      payload.hospitalName = formInputs.employeeName;
      payload.doctorsDetails = getDoctorsList.map((doctor) => ({
        doctorName: doctor.doctorName,
        doctorTitle: doctor.doctorTitle,
        doctorSpecialityCode: doctor.doctorSpecialityCode,
        doctorSpecialityName: doctor.doctorSpecialityName,
        doctorType: doctor.doctorType,
        doctorGender: doctor.doctorGender,
        doctorClass: doctor.doctorClass,
        doctorRentPercentage: doctor.doctorRentPercentage,
        doctorDiscountPercentage: doctor.doctorDiscountPercentage,
        doctorHospitalName: formInputs.employeeName,
        doctorHospitalAddress: formInputs.address,
        doctorHospitalCity: formInputs.city,
        doctorHospitalState: formInputs.state,
        doctorHospitalCountry: formInputs.country,
        doctorHospitalPincode: formInputs.cityPostalCode,
      }));
    } else if (selectedVendorCategory?.code === "V12") {
      payload.aadharNo = formInputs.aadharNo;
      payload.panNo = formInputs.panNo;
      payload.weight = formInputs.weight;
      payload.age = formInputs.age;
      payload.patientChallenges = formInputs.patientChallenges;
      payload.caregiverName = formInputs.caregiverName;
      payload.emailId = formInputs.emailId;
      payload.caregiverRelation = formInputs.caregiverRelation;
      payload.idProof = formInputs.idProof;
      payload.idProofNumber = formInputs.idProofNumber;
      payload.aadharCardAttachment = patientDocuments.aadharCardAttachment;
      payload.aadharCardFileName = patientDocuments.aadharCardFileName;
      payload.panCardAttachment = patientDocuments.panCardAttachment;
      payload.panCardFileName = patientDocuments.panCardFileName;

      payload.patientGender = formInputs.patientGender;
      payload.patientGenderCode = formInputs.patientGenderCode;

      payload.doctorsDetails = [
        {
          doctorHospitalName: formInputs.doctorHospitalName,
          doctorHospitalAddress: formInputs.doctorHospitalAddress,
          doctorHospitalCity: formInputs.doctorHospitalCity,
          doctorHospitalState: formInputs.doctorHospitalState,
          doctorHospitalCountry: formInputs.doctorHospitalCountry,
          doctorHospitalPincode: formInputs.doctorHospitalPincode,
        },
      ];
    } else if (selectedVendorCategory?.code === "V14") {
      //---Service Person-specific fields
      payload.aadharNo = formInputs.aadharNo;
      payload.servicePersonExpertise = formInputs.servicePersonExpertise;
      payload.servicePersonExperience = formInputs.servicePersonExperience;
      payload.servicePersonGender = formInputs.servicePersonGender;

      //---------Patient document attachments----------
      payload.aadharCardAttachment = patientDocuments.aadharCardAttachment;
      payload.aadharCardFileName = patientDocuments.aadharCardFileName;
    } else {
      payload.doctorsDetails = [];
    }

    return payload;
  };

  const handleUpdate = async () => {
    const requiredFields = [];
    let hasError = false;
    const validationErrors = {};

    // Basic validations
    if (!validateRequired(formInputs.employeeName)) {
      validationErrors.employeeName = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    } else if (!validateName(formInputs.employeeName)) {
      validationErrors.employeeName = message.VALID_CUSTOMER_NAME;
      requiredFields.push(message.VALID_CUSTOMER_NAME);
      hasError = true;
    }

    if (!validateRequired(formInputs.mobileNr)) {
      validationErrors.mobileNr = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    } else if (!validateContactNumber(formInputs.mobileNr)) {
      validationErrors.mobileNr = message.MOBILE_NUMBER;
      requiredFields.push(message.MOBILE_NUMBER);
      hasError = true;
    }

    if (selectedVendorCategory?.code !== "V13") {
      if (!validateRequired(formInputs.email)) {
        validationErrors.email = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateEmail(formInputs.email)) {
        validationErrors.email = message.VALID_MAIL_ID;
        hasError = true;
      }
    } else {
      // V13: only validate format if email is provided
      if (formInputs.email && !validateEmail(formInputs.email)) {
        validationErrors.email = message.VALID_MAIL_ID;
        hasError = true;
      }
    }

    if (!validateRequired(formInputs.address)) {
      validationErrors.address = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    }

    if (!validateRequired(formInputs.cityPostalCode)) {
      validationErrors.cityPostalCode = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    } else if (!validPostalCode(formInputs.cityPostalCode)) {
      validationErrors.cityPostalCode = message.VALID_POSTAL_CODE;
      requiredFields.push(message.VALID_POSTAL_CODE);
      hasError = true;
    }
    if (!validateRequired(formInputs.salesOfficerName)) {
      validationErrors.salesOfficerName = message.FILL_REQUIRED_FIELD;
      hasError = true;
    }

    if (!selectedVendorCategory?.code) {
      validationErrors.vendorCategory = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    }

    if (!validateRequired(formInputs.companyCode)) {
      validationErrors.companyCode = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    }

    // V11 validation
    if (selectedVendorCategory?.code === "V11") {
      if (!validateRequired(formInputs.doctorType)) {
        validationErrors.doctorType = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.employeeGender)) {
        validationErrors.employeeGender = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorClass)) {
        validationErrors.doctorClass = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }

      //  CRITICAL: Hospital details are REQUIRED for individual doctors
      if (!validateRequired(formInputs.doctorHospitalName)) {
        validationErrors.doctorHospitalName = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorHospitalAddress)) {
        validationErrors.doctorHospitalAddress = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorManagerName)) {
        validationErrors.doctorManagerName = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorGNT)) {
        validationErrors.doctorGNT = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
    }

    if (selectedVendorCategory?.code === "V13") {
      // 1. Agency/Provider
      if (!validateRequired(formInputs.serviceProviderName)) {
        validationErrors.serviceProviderName = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      // 2. Registration Number
      if (!validateRequired(formInputs.nurseRegNo)) {
        validationErrors.nurseRegNo = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      // 3. Category (Qualification)
      if (!validateRequired(formInputs.nurseCategory)) {
        validationErrors.nurseCategory = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      // 4. Specialization (Crucial for service mapping)
      if (!validateRequired(formInputs.nurseSpecialization)) {
        validationErrors.nurseSpecialization = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!validateRequired(formInputs.employeeGender)) {
        validationErrors.employeeGender = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
    }

    //  CONDITIONAL VALIDATION FOR PATIENT (V12) - Document Uploads
    if (selectedVendorCategory?.code === "V12") {
      if (!validateRequired(formInputs.aadharNo)) {
        validationErrors.aadharNo = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateAadhar(formInputs.aadharNo)) {
        validationErrors.aadharNo = message.VALID_AADHAAR_NUMBER;
        hasError = true;
      }
      if (!validateRequired(formInputs.panNo)) {
        validationErrors.panNo = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validatePAN(formInputs.panNo)) {
        validationErrors.panNo = message.VALID_PAN_NUMBER;
        hasError = true;
      }

      // Optional: Make document uploads mandatory
      if (!patientDocuments.aadharCardAttachment) {
        toast.error("Please upload Aadhaar card");
        hasError = true;
      }
      if (!patientDocuments.panCardAttachment) {
        toast.error("Please upload PAN card");
        hasError = true;
      }
    }

    if (selectedVendorCategory?.code === "V14") {
      if (!validateRequired(formInputs.aadharNo)) {
        validationErrors.aadharNo = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateAadhar(formInputs.aadharNo)) {
        validationErrors.aadharNo = message.VALID_AADHAAR_NUMBER;
        hasError = true;
      } else if (!validateName(formInputs.employeeName)) {
        validationErrors.employeeName = message.VALID_CUSTOMER_NAME;
        hasError = true;
      }
      //  Make document uploads mandatory
      if (!patientDocuments.aadharCardAttachment) {
        toast.error("Please upload Aadhaar card");
        hasError = true;
      }
    }

    // // Contact person validation
    // getcustomerContactPerson.forEach((doc) => {
    //   const id = doc.id;
    //   if (!doc.contactPosition) {
    //     validationErrors[`${id}_contactPosition`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   }
    //   if (!doc.contactName) {
    //     validationErrors[`${id}_contactName`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   } else if (!validateName(doc.contactName)) {
    //     validationErrors[`${id}_contactName`] = message.VALID_CUSTOMER_NAME;
    //     hasError = true;
    //   }
    //   if (!doc.contactNumber) {
    //     validationErrors[`${id}_contactNumber`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   } else if (!validateContactNumber(doc.contactNumber)) {
    //     validationErrors[`${id}_contactNumber`] = message.VALID_CONTACT_NUMBER;
    //     hasError = true;
    //   }
    // });

    // // Document validation
    // getDocumentTypeData.forEach((doc) => {
    //   const id = doc.id;
    //   if (!doc.documentType) {
    //     validationErrors[`${id}_documentType`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   }
    //   if (!doc.documentNumber) {
    //     validationErrors[`${id}_documentNumber`] = message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   }
    // });

    // // Bank validation
    // getBankDetails.forEach((doc) => {
    //   const id = doc.id;
    //   if (!doc.bankAccountNumber) {
    //     validationErrors[`${id}_bankAccountNumber`] =
    //       message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   } else if (!validateBankAccount(doc.bankAccountNumber)) {
    //     validationErrors[`${id}_bankAccountNumber`] = message.VALID_BANK_ACC;
    //     hasError = true;
    //   }
    //   if (!doc.AccountHolderName) {
    //     validationErrors[`${id}_AccountHolderName`] =
    //       message.FILL_REQUIRED_FIELD;
    //     hasError = true;
    //   }
    // });

    setValidation(validationErrors);

    if (hasError) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    const payload = buildPayload();
    const { _id, __v, password, ...cleanPayload } = payload;

    const updatedPayload = {
      ...cleanPayload,
      updatedAt: new Date().toISOString(),
      updatedBy: userInfo?.userId || "",
      timeZone: "Asia/Calcutta",
    };

    setDisabled(true);
    const toastId = toast.loading("Updating...");

    try {
      // console.log("payload for update", updatedPayload);
      const response = await ItemService.updateSupplierDocs(updatedPayload);

      if (response?.status === 200) {
        toast.success("Updated successfully!", { id: toastId });
        setEdit(true);
        setDisabled(true);
        await loadFirstLevelData();
      } else {
        toast.error(response?.message || "Update failed", { id: toastId });
        setDisabled(false);
      }
    } catch (err) {
      console.error("Update Error:", err);
      toast.error("Something went wrong", { id: toastId });
      setDisabled(false);
    }
  };

  // ============================================================================
  // DOCTORS HANDLERS (V04)
  // ============================================================================

  const addDoctor = () => {
    setDoctorsList((prev) => [
      ...prev,
      { ...doctorInitialData, id: Date.now() },
    ]);
  };

  const deleteDoctor = (id) => {
    setDoctorsList((prev) => prev.filter((doc) => doc.id !== id));
  };

  const handleDoctorInputChange = (id, fieldName, value) => {
    setDoctorsList((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
    );
  };

  // ============================================================================
  // CONTACT PERSON HANDLERS
  // ============================================================================

  const addCustomerCantactPerson = () => {
    setcustomerContactPerson((prev) => [
      ...prev,
      {
        id: Date.now(),
        contactPosition: "",
        contactTitle: "",
        contactName: "",
        contactNumber: "",
        contactEmail: "",
      },
    ]);
  };

  const deleteCustomerContactPerosn = (id) => {
    setcustomerContactPerson((prev) => prev.filter((doc) => doc.id !== id));
  };

  // const handleChangeCustomerContacts = (id, fieldName, value) => {
  //   const errors = {};

  //   if (fieldName === "contactName" && !validateName(value)) {
  //     errors[`${id}_${fieldName}`] = message.VALID_CUSTOMER_NAME;
  //   }

  //   if (fieldName === "contactNumber" && !validateContactNumber(value)) {
  //     errors[`${id}_${fieldName}`] = message.VALID_CONTACT_NUMBER;
  //   }

  //   setcustomerContactPerson((prev) =>
  //     prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
  //   );

  //   setValidation((prev) => ({ ...prev, ...errors }));
  // };

  const handleChangeCustomerContacts = (id, fieldName, value) => {
    const errors = {};

    //  UPDATED: Only validate format if user enters data
    // Don't make fields required anymore

    if (fieldName === "contactNumber" && value) {
      // Only validate if there's a value
      if (!validateContactNumber(value)) {
        errors[fieldName] = message.VALID_CONTACT_NUMBER;
      }
    }

    if (fieldName === "contactName" && value) {
      // Only validate if there's a value
      if (!validateName(value)) {
        errors[fieldName] = message.VALID_CUSTOMER_NAME;
      }
    }

    setcustomerContactPerson((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };

  // ============================================================================
  // DOCUMENT HANDLERS
  // ============================================================================

  const addDocumentType = () => {
    setDocumentTypeData((prev) => [
      ...prev,
      {
        id: Date.now(),
        name: `Document ${prev.length + 1}`,
        documentType: "",
        documentNumber: "",
        issueDate: "",
      },
    ]);
  };

  const deleteDocumentType = (id) => {
    setDocumentTypeData((prev) => prev.filter((doc) => doc.id !== id));
  };

  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
    );
  };

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prev) =>
      prev.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc,
      ),
    );
  };

  const onSuccessUploadAadhaarCard = (data) => {
    const fileName =
      data?.results?.[0]?.newFilename || data?.results?.[0]?.fileName || "";
    const attachmentId = data?.attachmentId || "";

    if (!fileName || !attachmentId) {
      toast.error("Upload failed: Missing file details.");
      return;
    }

    setPatientDocuments((prev) => ({
      ...prev,
      aadharCardAttachment: attachmentId,
      aadharCardFileName: fileName, // Update state with new system filename
    }));
    toast.success("Aadhaar card uploaded successfully");
  };

  const onSuccessUploadPanCard = (data) => {
    const fileName =
      data?.results?.[0]?.newFilename || data?.results?.[0]?.fileName || "";
    const attachmentId = data?.attachmentId || "";

    if (!fileName || !attachmentId) {
      toast.error("Upload failed: Missing file details.");
      return;
    }

    setPatientDocuments((prev) => ({
      ...prev,
      panCardAttachment: attachmentId,
      panCardFileName: fileName, // Update state with new system filename
    }));
    toast.success("PAN card uploaded successfully");
  };

  const handleDeletePatientDocument = async (docType) => {
    // 1. Determine which file we are deleting
    const isAadhar = docType === "aadhaar";

    const attachmentId = isAadhar
      ? patientDocuments.aadharCardAttachment
      : patientDocuments.panCardAttachment;

    const fileName = isAadhar
      ? patientDocuments.aadharCardFileName
      : patientDocuments.panCardFileName;

    // 2. Validation
    if (!attachmentId || !fileName) {
      console.error("Delete Error: Missing ID or Filename", {
        attachmentId,
        fileName,
      });
      toast.error("Cannot delete: File details missing.");
      return;
    }

    // 3. Construct Payload
    const documentData = {
      fileName: fileName,
      attachmentId: attachmentId,
      timeZone: "Asia/Calcutta",
    };

    try {
      // 4. Call API
      const response = await ItemService.deleteFile(documentData);

      if (
        response?.status === 200 ||
        response?.message === "File deleted successfully"
      ) {
        // 5. Update State on Success
        setPatientDocuments((prev) => ({
          ...prev,
          [isAadhar ? "aadharCardAttachment" : "panCardAttachment"]: "",
          [isAadhar ? "aadharCardFileName" : "panCardFileName"]: "",
        }));

        toast.success(
          `${isAadhar ? "Aadhaar" : "PAN"} card deleted successfully`,
        );
      } else {
        toast.error(response?.message || "Failed to delete document");
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Error deleting document");
    }
  };

  // ============================================================================
  // BANK HANDLERS
  // ============================================================================

  const addBankForm = () => {
    setBankDetails((prev) => [
      ...prev,
      { ...bankInfoInitialData, id: Date.now().toString() },
    ]);
  };

  const removeBankForm = (index) => {
    setBankDetails((prev) => prev.filter((_, i) => i !== index));
  };

  // const handleChangeBankInfo = (id, key, value) => {
  //   setBankDetails((prev) =>
  //     prev.map((item) => {
  //       if (item.id === id) {
  //         const updates = { [key]: value };

  //         if (key === "bankKey") {
  //           const selectedBank = getBankDetailsData.find(
  //             (bank) => bank.name === value,
  //           );
  //           if (selectedBank) {
  //             Object.assign(updates, {
  //               bankCountryDescription: selectedBank.bankCountryDescription,
  //               bankBranchName: selectedBank.bankBranchName,
  //               bankAddress: selectedBank.bankAddress,
  //             });
  //           }
  //         }

  //         return { ...item, ...updates };
  //       }
  //       return item;
  //     }),
  //   );

  //   const errorMsg =
  //     !value && key !== "swiftIfscCode" ? message.FILL_REQUIRED_FIELD : "";
  //   setValidation((prev) => ({ ...prev, [`${id}_${key}`]: errorMsg }));
  // };
  const handleChangeBankInfo = (id, key, value) => {
    setBankDetails((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const updates = { [key]: value };

          if (key === "bankKey") {
            const selectedBank = getBankDetailsData.find(
              (bank) => bank.name === value,
            );
            if (selectedBank) {
              Object.assign(updates, {
                bankCountryDescription: selectedBank.bankCountryDescription,
                bankAccountName: selectedBank.bankAccountName,
                bankAddress: selectedBank.bankAddress,
                bankBranchName: selectedBank.bankBranchName,
              });
            }
          }

          return { ...item, ...updates };
        }
        return item;
      }),
    );

    //  UPDATED: Remove the validation that makes fields required
    // Only clear any existing errors
    setValidation((prev) => ({
      ...prev,
      [`${id}_${key}`]: "", // Just clear errors, don't validate
    }));
  };

  const onSuccessUploadBankDocumentType = (data, index) => {
    setBankDetails((prev) => {
      const updated = [...prev];
      updated[index][data.fieldName] = data.attachmentId;
      return updated;
    });
  };

  // ============================================================================
  // FILE VIEWER
  // ============================================================================

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };
  const handleAttachmentDeleted = ({
    attachmentId,
    hasFiles,
    remainingCount,
  }) => {
    // If NO files remain, clear the field
    if (!hasFiles) {
      console.log("No files remaining, clearing attachment");
      setFormInputs((prev) => ({
        ...prev,
        [attachmentId.fieldName || attachmentId]: "", // Clear the attachment ID
      }));
    } else {
      // If files still exist, update with new count (optional)
      console.log("Files still exist, count:", remainingCount);
    }
  };
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={10} lg={10}>
                <h2 className="mainTitle">Details</h2>
              </Col>
              {edit ? (
                <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-end"
                >
                  <button className="btn btn-primary" onClick={handleEdit}>
                    <i className="bi bi-pencil-square px-2"></i>Edit
                  </button>
                </Col>
              ) : (
                <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-end gap-2"
                >
                  <button
                    className="btn btn-primary"
                    onClick={handleUpdate}
                    disabled={disabled}
                  >
                    <i className="bi bi-arrow-repeat px-2"></i>Update
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    <i className="bi bi-x-circle px-2"></i>Cancel
                  </button>
                </Col>
              )}
            </Row>
            <hr />

            {/* USER DETAILS */}
            <div className="accordion mb-4">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"}`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} className="text-center logoBtn">
                      <span className="iconLogo">U</span>
                    </Col>
                    <Col xs={8}>
                      <span className="headerTitle">User</span>
                      <span className="subHeaderTitle">
                        Information Overview
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          id="vendorCategory"
                          label="User Category"
                          name="vendorCategory"
                          code="vendorCategoryCode"
                          description="vendorCategoryDesc"
                          iconClassName="dropdownIcon"
                          data={vendorCategoryData}
                          setValue={selectedVendorCategory}
                          getvalue={setDropdownData}
                          error={validation?.vendorCategory}
                          disabled={true}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Name"
                          name="employeeName"
                          value={formInputs?.employeeName || ""}
                          onChange={onInputChange}
                          error={validation?.employeeName}
                          disabled={disabled}
                          required
                        />
                      </Col>

                      {selectedVendorCategory?.code === "V13" && (
                        <>
                          <Col xs={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Professional Nursing Details
                            </h6>
                          </Col>

                          <Row>
                            {/* Service Provider */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Service Provider (Agency)"
                                data={serviceProviderList}
                                name="serviceProviderName"
                                textField="name"
                                code="serviceProviderCode"
                                setValue={formInputs?.serviceProviderName}
                                getvalue={setDropdownData}
                                disabled={disabled} // Controlled by Edit mode
                                required={true}
                                error={validation?.serviceProviderName}
                              />
                            </Col>

                            {/* Reg No */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Nursing Council Reg No"
                                name="nurseRegNo"
                                value={formInputs?.nurseRegNo || ""}
                                onChange={onInputChange}
                                disabled={disabled}
                                required={true}
                                error={validation?.nurseRegNo}
                              />
                            </Col>

                            {/* Experience */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Years of Experience"
                                name="nurseExperience"
                                type="number"
                                value={formInputs?.nurseExperience || ""}
                                onChange={onInputChange}
                                disabled={disabled}
                                required={true}
                                error={validation?.nurseExperience}
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            {/* Category */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Nurse Category"
                                data={NURSE_CATEGORY_OPTIONS}
                                name="nurseCategory"
                                textField="name"
                                code="nurseCategoryCode"
                                setValue={formInputs?.nurseCategory}
                                getvalue={setDropdownData}
                                disabled={disabled}
                                required={true}
                                error={validation?.nurseCategory}
                              />
                            </Col>

                            {/* Specialization */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Specialization"
                                data={NURSE_SPECIALIZATION_OPTIONS}
                                name="nurseSpecialization"
                                textField="name"
                                code="nurseSpecializationCode"
                                setValue={formInputs?.nurseSpecialization}
                                getvalue={setDropdownData}
                                disabled={disabled}
                                required={true}
                                error={validation?.nurseSpecialization}
                              />
                            </Col>

                            {/* Languages */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Languages Known"
                                name="nurseLanguages"
                                value={formInputs?.nurseLanguages || ""}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Gender"
                                name="employeeGender"
                                code="employeeGenderCode"
                                description="employeeGenderDesc"
                                data={employeeGender}
                                id="employeeGender"
                                iconClassName="dropdownIcon"
                                setValue={formInputs?.employeeGender}
                                error={validation?.employeeGender}
                                getvalue={setDropdownData}
                                required={true}
                                disabled={disabled}
                              />
                            </Col>
                          </Row>
                        </>
                      )}

                      {selectedVendorCategory?.code === "V14" && (
                        <>
                          <Col xs={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Professional Details
                            </h6>
                          </Col>

                          {/* Row 1: Service Provider (Agency) & Registration */}
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Service Provider (Agency)"
                                placeholder="Select Service Provider"
                                data={serviceProviderList}
                                name="serviceProviderName"
                                textField="name"
                                code="serviceProviderCode"
                                setValue={formInputs.serviceProviderName}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation?.serviceProviderName}
                                id="serviceProviderName"
                                iconClassName="dropdownIcon"
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Years of Experience"
                                name="servicePersonExperience"
                                type="number"
                                placeholder="e.g. 5"
                                value={
                                  formInputs?.servicePersonExperience || ""
                                }
                                onChange={onInputChange}
                                required={true}
                                error={validation?.servicePersonExperience}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Gender"
                                name="servicePersonGender"
                                code="servicePersonGenderCode"
                                description="servicePersonGenderDesc"
                                data={employeeGender}
                                id="servicePersonGender"
                                iconClassName="dropdownIcon"
                                setValue={formInputs?.servicePersonGender}
                                error={validation?.servicePersonGender}
                                getvalue={setDropdownData}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Expertises"
                                name="servicePersonExpertise"
                                placeholder="Professional Skills"
                                value={formInputs?.servicePersonExpertise || ""}
                                onChange={onInputChange}
                                required={true}
                                error={validation?.servicePersonExpertise}
                                disabled={disabled}
                              />
                            </Col>
                          </Row>
                          {/* Aadhaar Number Input */}
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Aadhaar No"
                                name="aadharNo"
                                type="number"
                                placeholder="Enter Your Aadhar No"
                                required={true}
                                value={formInputs.aadharNo || ""}
                                onChange={onInputChange}
                                error={validation.aadharNo}
                                disabled={disabled}
                              />
                            </Col>

                            {/* Aadhaar Card Upload */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponent
                                    id="aadharCard"
                                    name="aadharCard"
                                    label="Upload Aadhaar Card"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={false}
                                    required={true}
                                    onSuccessUpload={onSuccessUploadAadhaarCard}
                                    value={
                                      patientDocuments.aadharCardAttachment ||
                                      ""
                                    }
                                    disabled={disabled}
                                  />
                                </Col>
                                <Col
                                  xs={2}
                                  md={2}
                                  lg={2}
                                  className="d-flex align-items-center"
                                >
                                  {patientDocuments.aadharCardAttachment && (
                                    <>
                                      {/* View Icon */}
                                      <img
                                        src="assets/img/newIcons/attached-file.png"
                                        className="attachmentIcon me-2"
                                        alt="view"
                                        onClick={() =>
                                          handleViewFile(
                                            patientDocuments.aadharCardAttachment,
                                          )
                                        }
                                        style={{ cursor: "pointer" }}
                                        title="View Aadhaar Card"
                                      />
                                      {/* Delete Icon -- Can be viewd only in edit mode*/}

                                      {!disabled && (
                                        <i
                                          className="bi bi-trash text-danger fs-5"
                                          onClick={() =>
                                            handleDeletePatientDocument(
                                              "aadhaar",
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                          title="Delete Aadhaar Card"
                                        />
                                      )}
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      )}

                      {/* V11 FIELDS */}
                      {selectedVendorCategory?.code === "V11" && (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Title"
                              name="doctorTitle"
                              value={formInputs?.doctorTitle || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Speciality Code"
                              name="doctorSpecialityCode"
                              value={formInputs?.doctorSpecialityCode || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Speciality Name"
                              name="doctorSpecialityName"
                              value={formInputs?.doctorSpecialityName || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Type"
                              name="doctorType"
                              value={formInputs?.doctorType || ""}
                              onChange={onInputChange}
                              error={validation?.doctorType}
                              disabled={disabled}
                              required
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Gender"
                              name="employeeGender"
                              data={employeeGender}
                              setValue={formInputs?.employeeGender}
                              getvalue={setDropdownData}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital/Clinic Name"
                              name="doctorHospitalName"
                              value={formInputs?.doctorHospitalName || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalName}
                              disabled={disabled}
                              required
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital Address"
                              name="doctorHospitalAddress"
                              value={formInputs?.doctorHospitalAddress || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital City"
                              name="doctorHospitalCity"
                              value={formInputs?.doctorHospitalCity || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Class"
                              name="doctorClass"
                              value={formInputs?.doctorClass || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Manager"
                              name="doctorManagerName"
                              data={doctorManagerDropDownOption}
                              setValue={formInputs?.doctorManagerName}
                              getvalue={setDropdownData}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <ComboboxField
                              label="Doctor GNT"
                              name="doctorGNT"
                              data={dropdownOption}
                              setValue={formInputs?.doctorGNT}
                              getvalue={setDropdownData}
                              disabled={disabled}
                            /> */}

                            <ComboboxField
                              label="Doctor GNT"
                              name="doctorGNT"
                              code="doctorGNTCode"
                              description="doctorGNTDesc"
                              data={dropdownOption}
                              id="doctorGNT"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.doctorGNT}
                              error={validation?.doctorGNT}
                              getvalue={setDropdownData}
                              disabled={disabled}
                              required={true}
                            />
                          </Col>
                        </>
                      )}

                      {/* COMMON FIELDS FOR ALL CATEGORIES */}
                      <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                        <h6 className="text-primary fw-bold ps-2">
                          Contact Information
                        </h6>
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Mobile"
                          name="mobileNr"
                          value={formInputs?.mobileNr || ""}
                          onChange={onInputChange}
                          error={validation?.mobileNr}
                          disabled={disabled}
                          required
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Email"
                          name="email"
                          value={formInputs?.email || ""}
                          onChange={onInputChange}
                          error={validation?.email}
                          disabled
                          required={selectedVendorCategory?.code !== "V13"}
                        />
                      </Col>

                      {selectedVendorCategory?.code === "V12" && (
                        <>
                          <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Document Information
                            </h6>
                          </Col>

                          {/* Aadhaar Number Input */}
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Aadhaar No"
                                name="aadharNo"
                                type="number"
                                placeholder="Enter Your Aadhar No"
                                required={true}
                                value={formInputs.aadharNo || ""}
                                onChange={onInputChange}
                                error={validation.aadharNo}
                                disabled={disabled}
                              />
                            </Col>

                            {/* Aadhaar Card Upload */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponent
                                    id="aadharCard"
                                    name="aadharCard"
                                    label="Upload Aadhaar Card"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={false}
                                    required={true}
                                    onSuccessUpload={onSuccessUploadAadhaarCard}
                                    value={
                                      patientDocuments.aadharCardAttachment ||
                                      ""
                                    }
                                    disabled={disabled}
                                  />
                                </Col>
                                <Col
                                  xs={2}
                                  md={2}
                                  lg={2}
                                  className="d-flex align-items-center"
                                >
                                  {patientDocuments.aadharCardAttachment && (
                                    <>
                                      {/* View Icon */}
                                      <img
                                        src="assets/img/newIcons/attached-file.png"
                                        className="attachmentIcon me-2"
                                        alt="view"
                                        onClick={() =>
                                          handleViewFile(
                                            patientDocuments.aadharCardAttachment,
                                          )
                                        }
                                        style={{ cursor: "pointer" }}
                                        title="View Aadhaar Card"
                                      />
                                      {/* Delete Icon -- Can be viewd only in edit mode*/}

                                      {!disabled && (
                                        <i
                                          className="bi bi-trash text-danger fs-5"
                                          onClick={() =>
                                            handleDeletePatientDocument(
                                              "aadhaar",
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                          title="Delete Aadhaar Card"
                                        />
                                      )}
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row>
                            {/* PAN Number Input */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="PAN No"
                                name="panNo"
                                required={true}
                                placeholder="Enter Pan No"
                                value={formInputs.panNo || ""}
                                onChange={onInputChange}
                                error={validation.panNo}
                                disabled={disabled}
                              />
                            </Col>

                            {/* PAN Card Upload - New Row */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponent
                                    id="panCard"
                                    name="panCard"
                                    label="Upload PAN Card"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={false}
                                    required={true}
                                    onSuccessUpload={onSuccessUploadPanCard}
                                    value={
                                      patientDocuments.panCardAttachment || ""
                                    }
                                    disabled={disabled}
                                  />
                                </Col>
                                <Col
                                  xs={2}
                                  md={2}
                                  lg={2}
                                  className="d-flex align-items-center"
                                >
                                  {patientDocuments.panCardAttachment && (
                                    <>
                                      {/* View Icon */}
                                      <img
                                        src="assets/img/newIcons/attached-file.png"
                                        className="attachmentIcon me-2"
                                        alt="view"
                                        onClick={() =>
                                          handleViewFile(
                                            patientDocuments.panCardAttachment,
                                          )
                                        }
                                        style={{ cursor: "pointer" }}
                                        title="View PAN Card"
                                      />
                                      {/* Delete Icon -- Can be viewd only in edit mode */}
                                      {!disabled && (
                                        <i
                                          className="bi bi-trash text-danger fs-5"
                                          onClick={() =>
                                            handleDeletePatientDocument("pan")
                                          }
                                          style={{ cursor: "pointer" }}
                                          title="Delete PAN Card"
                                        />
                                      )}
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Extra Information
                            </h6>
                          </Col>

                          <Row>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Weight"
                                name="weight"
                                type="number"
                                placeholder="Enter Patient Weight"
                                // required={true}
                                value={formInputs.weight || ""}
                                onChange={onInputChange}
                                error={validation.weight}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Age"
                                name="age"
                                type="number"
                                placeholder="Enter Patient Age"
                                // required={true}
                                value={formInputs.age || ""}
                                onChange={onInputChange}
                                error={validation.age}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Gender"
                                name="patientGender"
                                code="patientGenderCode"
                                description="patientGenderDesc"
                                data={employeeGender}
                                id="patientGender"
                                iconClassName="dropdownIcon"
                                setValue={formInputs?.patientGender}
                                getvalue={setDropdownData}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Patient Challenges"
                                name="patientChallenges"
                                value={formInputs.patientChallenges}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <InputField
                                className="inputBox"
                                label="Caregiver Name"
                                name="caregiverName"
                                value={formInputs.caregiverName}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <InputField
                                className="inputBox"
                                label="Caregiver Mobile No"
                                name="caregiverMobileNr"
                                value={formInputs.caregiverMobileNr}
                                onChange={onInputChange}
                                required={true}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <InputField
                                className="inputBox"
                                label="Caregiver Email ID"
                                name="emailId"
                                value={formInputs.emailId}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <InputField
                                className="inputBox"
                                label="Relationship"
                                name="caregiverRelation"
                                value={formInputs.caregiverRelation}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <ComboboxField
                                label="ID Proof Type"
                                data={ID_PROOF_OPTIONS}
                                name="idProof"
                                textField="name"
                                setValue={formInputs.idProof}
                                getvalue={setDropdownData}
                                disabled={disabled}
                              />
                            </Col>
                            {formInputs.idProof &&
                              formInputs.idProof !== "Select" && (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding mb-3"
                                >
                                  <InputField
                                    className="inputBox"
                                    label={`${formInputs.idProof} Number`}
                                    name="idProofNumber"
                                    placeholder={`Enter ${formInputs.idProof} number`}
                                    value={formInputs.idProofNumber}
                                    onChange={onInputChange}
                                    error={validation.idProofNumber}
                                    disabled={disabled}
                                  />
                                </Col>
                              )}
                          </Row>
                        </>
                      )}

                      <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                        <h6 className="text-primary fw-bold ps-2">
                          {selectedVendorCategory?.code === "V11"
                            ? "Personal Address"
                            : "Address Details"}
                        </h6>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 1"
                          name="address"
                          value={formInputs?.address || ""}
                          onChange={onInputChange}
                          error={validation?.address}
                          disabled={disabled}
                          required
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="address2"
                          value={formInputs?.address2 || ""}
                          onChange={onInputChange}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="city"
                          value={formInputs?.city || ""}
                          onChange={onInputChange}
                          disabled={disabled}
                          required
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Country"
                          name="country"
                          data={getCountry}
                          setValue={formInputs?.country}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="State"
                          name="state"
                          data={getState}
                          setValue={formInputs?.state}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Postal Code"
                          name="cityPostalCode"
                          value={formInputs?.cityPostalCode || ""}
                          onChange={onInputChange}
                          error={validation?.cityPostalCode}
                          disabled={disabled}
                          required
                        />
                      </Col>

                      {selectedVendorCategory?.code === "V12" && (
                        <>
                          {/*  Optional Details of Hospital for Individual Patinet */}
                          <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                            <h6 className="text-primary fw-bold ps-2">
                              Hospital/Clinic Details Where You Visit
                            </h6>
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital/Clinic Name"
                              name="doctorHospitalName"
                              placeholder="Enter hospital or clinic name"
                              value={formInputs?.doctorHospitalName || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalName}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital/Clinic Address"
                              name="doctorHospitalAddress"
                              placeholder="Enter hospital or clinic address"
                              value={formInputs?.doctorHospitalAddress || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalAddress}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital City"
                              name="doctorHospitalCity"
                              placeholder="Enter city"
                              value={formInputs?.doctorHospitalCity || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalCity}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital State"
                              name="doctorHospitalState"
                              placeholder="Enter state"
                              value={formInputs?.doctorHospitalState || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalState}
                              disabled={disabled}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital Pincode"
                              name="doctorHospitalPincode"
                              placeholder="Enter pincode"
                              value={formInputs?.doctorHospitalPincode || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalPincode}
                              disabled={disabled}
                            />
                          </Col>
                        </>
                      )}

                      <Col xs={12} md={12} lg={12} className="mt-3 mb-2">
                        <h6 className="text-primary fw-bold ps-2">
                          Other Details
                        </h6>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Code"
                          name="companyCode"
                          data={getCompanyCode}
                          setValue={formInputs?.companyCode}
                          getvalue={setDropdownData}
                          error={validation?.companyCode}
                          disabled={disabled}
                          required
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Sales Officer Name"
                          name="salesOfficerName"
                          code="salesOfficerCode"
                          description="salesOfficerDesc"
                          data={getSalesOfficerList}
                          id="salesOfficerName"
                          iconClassName="dropdownIcon"
                          // If user is M000, disabled is false. Otherwise, it is true.
                          disabled={
                            disabled ||
                            !userData?.roles?.some(
                              (role) => role.roleId === "SALES-ADMIN",
                            )
                          }
                          setValue={formInputs?.salesOfficerName}
                          error={validation.salesOfficerName}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Joining Date"
                          name="joiningDate"
                          type="date"
                          min="2000-01-01"
                          value={formatDateForInput(formInputs?.joiningDate)}
                          onChange={onInputChange}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="activeInactive"
                          >
                            Active/Inactive
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="activeInactive"
                            id="activeInactive"
                            checked={formInputs?.activeInactive || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                activeInactive: e.target.checked,
                              }))
                            }
                          />
                          <span className="ms-2">
                            {formInputs?.activeInactive ? "Active" : "Inactive"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* DOCTORS LIST (V04) */}
            {selectedVendorCategory?.code === "V04" && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible10 ? "bi-chevron-right" : "bi-chevron-down"}`}
                          onClick={toggleCardVisibility10}
                        ></i>
                      </Col>
                      <Col xs={1} className="text-center logoBtn">
                        <span className="iconLogo">DR</span>
                      </Col>
                      <Col xs={4} md={8} lg={8}>
                        <span className="headerTitle">Doctors List</span>
                        <span className="subHeaderTitle">
                          Add doctors employed by this hospital
                        </span>
                      </Col>
                      <Col
                        xs={4}
                        md={2}
                        lg={2}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={addDoctor}
                          disabled={disabled}
                        >
                          <i className="bi bi-plus-lg"></i> Add Doctor
                        </button>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""}`}
                  >
                    <div className="accordion-body">
                      {getDoctorsList.map((doc) => (
                        <Row key={doc.id} className="mb-3 border-bottom pb-3">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Title"
                              value={doc.doctorTitle}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorTitle",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Name"
                              value={doc.doctorName}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorName",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Speciality Code"
                              name="doctorSpecialityCode"
                              placeholder="e.g. VS, DR, EN"
                              value={doc.doctorSpecialityCode}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorSpecialityCode",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Speciality"
                              name="doctorSpecialityName"
                              value={doc.doctorSpecialityName}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorSpecialityName",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Type"
                              name="doctorType"
                              placeholder="e.g. Doctor, Physio"
                              value={doc.doctorType}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorType",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              className="inputBox"
                              label="Gender"
                              name="doctorGender"
                              code="doctorGenderCode"
                              description="doctorGenderDesc"
                              id="doctorGender"
                              data={employeeGender}
                              setValue={doc.doctorGender}
                              getvalue={setDropdownData}
                              index={doc.id}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Class"
                              name="doctorClass"
                              placeholder="e.g. FA, CORE"
                              value={doc.doctorClass}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorClass",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Rent Percentage"
                              name="doctorRentPercentage"
                              type="number"
                              value={doc.doctorRentPercentage}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorRentPercentage",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Discount Rate"
                              type="number"
                              name="doctorDiscountPercentage"
                              value={doc.doctorDiscountPercentage}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorDiscountPercentage",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={1}
                            lg={1}
                            className="commTopButtonRightLeftPadding d-flex align-items-center mt-4"
                          >
                            {!disabled && (
                              <i
                                className="bi bi-trash text-danger fs-4 cursor-pointer"
                                onClick={() => deleteDoctor(doc.id)}
                                title="Delete Doctor"
                              ></i>
                            )}
                          </Col>
                        </Row>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addCustomerCantactPerson}
                          disabled={disabled}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Job Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Person
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Email-ID
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getcustomerContactPerson.map((doc) => (
                                      <Row key={doc.id} className="mb-3">
                                        <Col
                                          xs={12}
                                          md={2}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            placeholder="Job Title"
                                            data={getcontactPosition}
                                            setValue={doc.contactPosition}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={2}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            placeholder="Contact Title"
                                            data={getTitle}
                                            setValue={doc.contactTitle}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={2}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Contact Person"
                                            value={doc.contactName || ""}
                                            onChange={(e) =>
                                              handleChangeCustomerContacts(
                                                doc.id,
                                                "contactName",
                                                e.target.value,
                                              )
                                            }
                                            error={
                                              validation[
                                                `${doc.id}_contactName`
                                              ]
                                            }
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={2}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Contact Number"
                                            value={doc.contactNumber || ""}
                                            onChange={(e) =>
                                              handleChangeCustomerContacts(
                                                doc.id,
                                                "contactNumber",
                                                e.target.value,
                                              )
                                            }
                                            error={
                                              validation[
                                                `${doc.id}_contactNumber`
                                              ]
                                            }
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={2}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Email"
                                            value={doc.contactEmail || ""}
                                            onChange={(e) =>
                                              handleChangeCustomerContacts(
                                                doc.id,
                                                "contactEmail",
                                                e.target.value,
                                              )
                                            }
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={1}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {!disabled && (
                                            <i
                                              onClick={() =>
                                                deleteCustomerContactPerosn(
                                                  doc.id,
                                                )
                                              }
                                              className="bi bi-trash text-danger fs-4 cursor-pointer"
                                            />
                                          )}
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* customer Document Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Document Type</span>
                      <span className="subHeaderTitle">Document Type</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          disabled={disabled}
                          onClick={addDocumentType}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      {/* <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issuing Authority
                                        </p>
                                      </Col> */}
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc) => (
                                      <Row key={doc.id} className="mb-3">
                                        <Col
                                          xs={12}
                                          md={2}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            setValue={doc.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={2}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value,
                                              )
                                            }
                                            error={
                                              validation[
                                                `${doc.id}_documentNumber`
                                              ]
                                            }
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={2}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={formatDateForInput(
                                              doc.issueDate,
                                            )}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value,
                                              )
                                            }
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={1}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {doc.iSOCertification ? (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification,
                                                  )
                                                }
                                              />
                                            ) : (
                                              "--"
                                            )}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={false}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={1}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {!disabled && (
                                            <i
                                              onClick={() =>
                                                deleteDocumentType(doc.id)
                                              }
                                              className="bi bi-trash text-danger fs-4 cursor-pointer"
                                            />
                                          )}
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* BANK INFORMATION */}
            <div className="accordion mb-4">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible8 ? "bi-chevron-right" : "bi-chevron-down"}`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Bank Information</span>
                    </Col>
                    <Col xs={6} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={addBankForm}
                        disabled={disabled}
                      >
                        <i className="bi bi-plus-lg"></i> Add Bank Info
                      </button>
                    </Col>
                    {/* <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col> */}
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    {getBankDetails.map((item, index) => (
                      <div key={item.id}>
                        <Row className="pt-2 pb-2">
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commTopButtonRightLeftPadding"
                          >
                            <h6>Bank Information Section {index + 1}</h6>
                            {!disabled && (
                              <span
                                className="deleteIconAccordion"
                                onClick={() => removeBankForm(index)}
                              >
                                <i className="bi bi-x-circle"></i>
                              </span>
                            )}
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank IFSC"
                              name="bankIFSC"
                              value={item?.bankIFSC}
                              onChange={(e) =>
                                handleChangeBankInfo(
                                  item.id,
                                  "bankIFSC",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank A/C Number"
                              name="bankAccountNumber"
                              value={item?.bankAccountNumber}
                              onChange={(e) =>
                                handleChangeBankInfo(
                                  item.id,
                                  "bankAccountNumber",
                                  e.target.value,
                                )
                              }
                              error={validation[`${item.id}_bankAccountNumber`]}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank Name"
                              name="bankBranchName"
                              value={item?.bankBranchName}
                              onChange={(e) =>
                                handleChangeBankInfo(
                                  item.id,
                                  "bankBranchName",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Account Holder Name"
                              name="AccountHolderName"
                              value={item?.AccountHolderName}
                              onChange={(e) =>
                                handleChangeBankInfo(
                                  item.id,
                                  "AccountHolderName",
                                  e.target.value,
                                )
                              }
                              error={validation[`${item.id}_AccountHolderName`]}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Preferred Currency"
                              name="preferredCurrency"
                              value={item?.preferredCurrency}
                              onChange={(e) =>
                                handleChangeBankInfo(
                                  item.id,
                                  "preferredCurrency",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="IFSC Code"
                              name="swiftIfscCode"
                              data={dropdownOption}
                              setValue={item?.swiftIfscCode}
                              getvalue={setDropdownData}
                              index={item.id}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <FileUploadComponentForHB
                              id="bankCompanyletterhead"
                              name="bankCompanyletterhead"
                              label="Company letterhead"
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true}
                              required={true}
                              onSuccessUpload={(data) =>
                                onSuccessUploadBankDocumentType(data, index)
                              }
                              value={item?.bankCompanyletterhead || ""}
                              disabled={disabled}
                            />
                            <div className="d-flex align-items-center pe-2">
                              {item?.bankCompanyletterhead ? (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(item?.bankCompanyletterhead)
                                  }
                                />
                              ) : (
                                "--"
                              )}
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <FileUploadComponentForHB
                              id="bankConfirmationLetter"
                              name="bankConfirmationLetter"
                              label="Confirmation letter"
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true}
                              required={true}
                              onSuccessUpload={(data) =>
                                onSuccessUploadBankDocumentType(data, index)
                              }
                              value={item?.bankConfirmationLetter || ""}
                              disabled={disabled}
                            />
                            <div className="d-flex align-items-center pe-2">
                              {item?.bankConfirmationLetter ? (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(item?.bankConfirmationLetter)
                                  }
                                />
                              ) : (
                                "--"
                              )}
                            </div>
                          </Col>
                        </Row>
                        <hr />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={hideFailureModal}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      {/* <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData} */}
      {/* /> */}
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}
        showDelete={!disabled}
      />
    </main>
  );
};

export default UserRegistrationDetailsMR;
